import PageTitle from 'Components/PageTitle'
import LoginCard from 'Services/common/Features/User/Components'
import useTypedSelector from 'Store'
import { HSL_ENABLED_FEATURES, WALTTI_ENABLED_FEATURES } from 'Util/constants'
import { Box, Typography } from '@mui/material'
import HSLLogo from 'assets/images/hsl-logo.png'
import WalttiLogo from 'assets/images/waltti-logo.png'
import Cookies from 'js-cookie'
import { type FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

const WALTTI_LOGIN_METHOD = {
  title: 'Waltti ID',
  image: WalttiLogo
}

const HSL_LOGIN_METHOD = {
  title: 'HSL ID',
  image: HSLLogo
}

const LoginPage: FC = () => {
  const isAuthed = useTypedSelector(state => state.user.authed)

  const navigate = useNavigate()
  const redirectUrl = Cookies.get('redirectUrl')

  useEffect(() => {
    if (isAuthed) {
      if (redirectUrl) {
        Cookies.remove('redirectUrl')
        navigate(redirectUrl, { replace: true })
      } else {
        navigate('/', { replace: true })
      }
    }
  }, [isAuthed, navigate])

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 2 }}>
        <PageTitle>{t`Login required`}</PageTitle>
        <Typography component="p" variant="subtitle1" sx={{ fontSize: '15px', mb: 4 }}>
          {t`In order to use Waltti Manager you need to login through ID service. The link below will take you to the login page maintained by ID service. Once you have successfully logged in, you will be automatically redirected back to Waltti Manager.`}
        </Typography>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={3}>
          {WALTTI_ENABLED_FEATURES && (
            <LoginCard title={WALTTI_LOGIN_METHOD.title} image={WALTTI_LOGIN_METHOD.image} />
          )}
          {HSL_ENABLED_FEATURES && (
            <LoginCard title={HSL_LOGIN_METHOD.title} image={HSL_LOGIN_METHOD.image} />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default LoginPage
